import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {LibTableColumnModel} from "../../lib-table/lib-table.component";

export class LibTableUtil {

    public static DEFAULT_PAGE_SIZE = 100;
    public static DEFAULT_PAGE_SIZE_20 = 20;
    public static DEFAULT_PAGE_SIZE_30 = 30;
    public static DEFAULT_PAGE_SIZE_10 = 10;
    public static DEFAULT_PAGE_SIZE_1 = 1;
    public static DEFAULT_BACKEND_PAGE_SIZE = 20;
    public static DEFAULT_PAGE_INDEX = 0;
    public static DEFAULT_PAGE_SIZE_OPTIONS: number[] = [5, 10, 20, 50, 100, 200, 500];

    public static initializeTableDatasource(): MatTableDataSource<any> {
        const tableDataSource = new MatTableDataSource();
        tableDataSource.sortingDataAccessor = this.pathDataAccessor;
        tableDataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                return this.nestedFilterCheck(currentTerm, data, key);
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };
        return tableDataSource;
    }

    public static pathDataAccessor(item: any, path: string): any {
        return path.split('.')
            .reduce((accumulator: any, key: string) => {
                return accumulator ? accumulator[key] : undefined;
            }, item);
    }

    private static nestedFilterCheck(search, data, key) {
        if (typeof data[key] === 'object') {
            for (const k in data[key]) {
                if (data[key][k] !== null) {
                    search = this.nestedFilterCheck(search, data[key], k);
                }
            }
        } else {
            search += data[key];
        }
        return search;
    }

    public static onFilterChange(tableDataSource: MatTableDataSource<any>, value: string): MatTableDataSource<any> {
        if (!tableDataSource) {
            // @ts-ignore
            return;
        }
        value = value?.trim()?.toLowerCase();
        tableDataSource.filter = value;
        return tableDataSource;
    }

    public static trackByProperty<T>(index: number, column: LibTableColumnModel<T>) {
        return column.property;
    }

    public static isAllSelected(selection: SelectionModel<any>, tableDataSource: MatTableDataSource<any>): boolean {
        const numSelected = selection?.selected?.length;
        const numRows = tableDataSource?.data?.length;
        return numSelected === numRows;
    }

    public static masterToggle(selection: SelectionModel<any>, tableDataSource: MatTableDataSource<any>): void {
        if (this.isAllSelected(selection, tableDataSource)) {
            selection.clear();
        } else {
            tableDataSource.data.forEach(row => selection?.select(row));
        }
    }

    public static toggleColumnVisibility(column, event): void {
        event.stopPropagation();
        event.stopImmediatePropagation();
        column.visible = !column.visible;
    }

    public static getVisibleColumns(columns: LibTableColumnModel<any> []) {
        return columns?.filter(column => column.visible).map(column => column.property);
    }

    public static isTableEmpty(tableDataSource: MatTableDataSource<any>): boolean {
        return tableDataSource?.data?.length === 0 || tableDataSource?.filteredData?.length === 0;
    }

    public static getEnumValue(item: any, property: string, enumClass: any): string {
        const value = this.pathDataAccessor(item, property);
        return enumClass[value];
    }
}
